import React from 'react'
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Box, Button, Divider, Paper, Skeleton, Typography } from '@mui/material';
import ReactHTMLParser from 'react-html-parser'
import { CloudDownload } from '@mui/icons-material';

const ReadingPane = () => {
  const { id } = useParams();
  const posts = useSelector(state => state.app.posts);
  const currentPost = posts.find(post => post.id === Number(id));

  return (
    <Paper sx={{p: 2.5,}}>
      {
        currentPost ?
          (
            <Typography component="h1" variant="h2" fontWeight={600}>
              { ReactHTMLParser(currentPost?.title?.rendered) }
            </Typography>
          ) :
          <Skeleton variant="rounded" height={72} width="100%" />
      }
      {
        currentPost ?
          (
            <Typography>
              {currentPost?.acf?.short_description}
            </Typography>
          ) :
          <Skeleton fontSize={24}  />
      }
      {
        currentPost?.acf?.download_uri ? (
          <Button
            color="secondary"
            endIcon={<CloudDownload />}
            href={currentPost?.acf?.download_uri}
            sx={{my: 1, width: 300,}}
            variant="contained"
            disabled={!currentPost}
          >
            { currentPost ? "Download Installer" : <Skeleton fontSize={16.5} width="100%" />}
          </Button>
        ) : null
      }
      <Divider />
      {
        currentPost?.acf?.video_uri ? (
          <React.Fragment>
            {
              currentPost ? (
                <Box
                  component="iframe"
                  src={currentPost?.acf?.video_uri}
                  sx={{border: 0, borderRadius: 1, height: 400, marginY: 1, width: "100%"}}
                ></Box>
              ) : <Skeleton variant="rounded" height={400} width="100%" sx={{marginY: 1}} />
            }
          </React.Fragment>
        ) : null
      }
      <Divider />
      <Box component="div">
        {ReactHTMLParser(currentPost?.content?.rendered)}
      </Box>
    </Paper>
  )
}

export default ReadingPane
